import script from "./SubmitAdvisorView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubmitAdvisorView.vue?vue&type=script&lang=ts&setup=true"

import "./SubmitAdvisorView.vue?vue&type=style&index=0&id=74899da9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74899da9"]])

export default __exports__